import type { Dispatch, AnyAction } from 'redux';

import * as BulkUpsertJobMaterialCostAPI from 'ab-api/web/jobMaterialCost/bulkUpsert';
import * as FindForJobMaterialAPI from 'ab-api/web/jobMaterialCost/findForJobMaterial';
import * as RemoveScheduledCostForMaterialAPI from 'ab-api/web/jobMaterialCost/removeScheduledCostForMaterial';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

export function bulkUpsertJobMaterialCost(jobId: number, data: BulkUpsertJobMaterialCostAPI.W_JobMaterialCost_BulkUpsert_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.put<void>(BulkUpsertJobMaterialCostAPI.URL(jobId), data);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findForJobMaterial(jobMaterialId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<FindForJobMaterialAPI.W_JobMaterialCostHistory_FindForJobMaterial_VM>(FindForJobMaterialAPI.URL(jobMaterialId));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function removeScheduledCostForMaterial(jobMaterialId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.delete(RemoveScheduledCostForMaterialAPI.URL(jobMaterialId));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
